module.exports = __webpack_public_path__ + "static/media/jquery.c6171aaf.svg";